import * as React from 'react';

export const nzFlagContent: JSX.Element = (
    <>
        <g clipPath='url(#clip0_1_nz)'>
            <rect
                width='28'
                height='20'
                rx='4'
                fill='#1A47B8'
            />
            <mask
                id='mask0_1_nz'
                style={{ maskType: 'alpha' }}
                maskUnits='userSpaceOnUse'
                x='0'
                y='0'
                width='28'
                height='20'
            >
                <path
                    d='M0 4C0 1.79086 1.79086 0 4 0H24C26.2091 0 28 1.79086 28 4V16C28 18.2091 26.2091 20 24 20H4C1.79086 20 0 18.2091 0 16V4Z'
                    fill='#D9D9D9'
                />
            </mask>
            <g mask='url(#mask0_1_nz)'>
                <path
                    d='M25.3333 0H2.66667C1.19391 0 0 1.19391 0 2.66667V17.3333C0 18.8061 1.19391 20 2.66667 20H25.3333C26.8061 20 28 18.8061 28 17.3333V2.66667C28 1.19391 26.8061 0 25.3333 0Z'
                    fill='#1A47B8'
                />
                <mask
                    id='mask1_1_nz'
                    style={{ maskType: 'alpha' }}
                    maskUnits='userSpaceOnUse'
                    x='0'
                    y='-1'
                    width='15'
                    height='11'
                >
                    <path
                        d='M0 -0.459961H14.6701V9.29797H0V-0.459961Z'
                        fill='#000008'
                    />
                </mask>
                <g mask='url(#mask1_1_nz)'>
                    <path
                        d='M15.2109 0.352539L9.09668 4.41895L15.2109 8.48535L14.1299 10.1104L7.33496 5.58984L0.540039 10.1104L-0.540039 8.48535L5.57324 4.41895L-0.540039 0.352539L0.540039 -1.27246L7.33496 3.24707L14.1299 -1.27246L15.2109 0.352539Z'
                        fill='#F1F5F9'
                    />
                </g>
                <mask
                    id='mask2_1_nz'
                    style={{ maskType: 'alpha' }}
                    maskUnits='userSpaceOnUse'
                    x='0'
                    y='-1'
                    width='15'
                    height='11'
                >
                    <path
                        d='M0 -0.459961V4.419H14.6701V9.29797L0 -0.459961ZM14.6701 -0.459961H7.33504V9.29797H0L14.6701 -0.459961Z'
                        fill='#000008'
                    />
                </mask>
                <g mask='url(#mask2_1_nz)'>
                    <path
                        d='M15.0303 0.0820312L8.50977 4.41895L15.0303 8.75586L14.3096 9.83984L7.33496 5.2002L0.360352 9.83984L-0.360352 8.75586L6.15918 4.41895L-0.360352 0.0820312L0.360352 -1.00195L7.33496 3.63672L14.3096 -1.00195L15.0303 0.0820312Z'
                        fill='#F93939'
                    />
                </g>
                <path
                    d='M8.96104 -0.459961V2.79301H14.6701V6.045H8.96104V9.29797H5.70905V6.045H0V2.79301H5.70905V-0.459961H8.96104Z'
                    fill='#F1F5F9'
                />
                <path
                    d='M8.31064 -0.459961V3.44341H14.6701V5.3946H8.31064V9.29797H6.35945V5.3946H0V3.44341H6.35945V-0.459961H8.31064Z'
                    fill='#F93939'
                />
                <path
                    d='M19.6667 3.66667L20.3333 5.33333L22 6L20.3333 6.66667L19.6667 8.33333L19 6.66667L17.3333 6L19 5.33333L19.6667 3.66667Z'
                    fill='#F1F5F9'
                />
                <path
                    d='M19.8333 4.33333L20.3333 5.5L21.5 6L20.3333 6.5L19.8333 7.66667L19.3333 6.5L18.1667 6L19.3333 5.5L19.8333 4.33333Z'
                    fill='#F93939'
                />
                <path
                    d='M23.3333 7L24 8.33333L25.3333 9L24 9.66667L23.3333 11L22.6667 9.66667L21.3333 9L22.6667 8.33333L23.3333 7Z'
                    fill='#F1F5F9'
                />
                <path
                    d='M23.5 7.66667L24 8.5L25 9L24 9.5L23.5 10.3333L23 9.5L22 9L23 8.5L23.5 7.66667Z'
                    fill='#F93939'
                />
                <path
                    d='M17 9L17.6667 10.3333L19 11L17.6667 11.6667L17 13L16.3333 11.6667L15 11L16.3333 10.3333L17 9Z'
                    fill='#F1F5F9'
                />
                <path
                    d='M17.1667 9.66667L17.6667 10.5L18.6667 11L17.6667 11.5L17.1667 12.3333L16.6667 11.5L15.6667 11L16.6667 10.5L17.1667 9.66667Z'
                    fill='#F93939'
                />
                <path
                    d='M20.3333 13L21.1667 14.8333L23 15.6667L21.1667 16.5L20.3333 18.3333L19.5 16.5L17.6667 15.6667L19.5 14.8333L20.3333 13Z'
                    fill='#F1F5F9'
                />
                <path
                    d='M20.5 13.8333L21.1667 15.1667L22.5 15.6667L21.1667 16.1667L20.5 17.5L19.8333 16.1667L18.5 15.6667L19.8333 15.1667L20.5 13.8333Z'
                    fill='#F93939'
                />
            </g>
        </g>
        <defs>
            <clipPath id='clip0_1_nz'>
                <rect
                    width='28'
                    height='20'
                    rx='4'
                    fill='white'
                />
            </clipPath>
        </defs>
    </>
);
